<template>
   <!-- Start Footerbar -->
            <div class="footerbar">
                <footer class="footer">
                    <p class="mb-0">© {{  new Date().getFullYear() }} CRM<sup>2</sup> Corriere Romagna -  Powered by <a
              href="https://www.e-project.it"
              target="_blank"
            >
              <img
                src="assets/images/eprj.png"
                style="width:18px; vertical-align:middle;"
              ></a></p>
                </footer> 
            </div>
            <!-- End Footerbar -->
</template>

<script>
export default {
  name: 'AppFooter'
};
</script>

<style>
</style>
